import { useEffect, useSyncExternalStore } from 'react';

import Cookies from 'js-cookie';

import { isAuthenticated, onUserStateChange } from '../features/authentication/authentication';

export function isSuspendedAndAuthenticated(): boolean {
  return isAuthenticated() && Boolean(Cookies.get('account_suspended'));
}

export function useIsSuspended(): boolean {
  return useSyncExternalStore(onUserStateChange, isSuspendedAndAuthenticated);
}

export function useSuspendedCookie() {
  const isUserSuspended = useIsSuspended();

  useEffect(() => {
    if (isUserSuspended) {
      // this is needed to try and manage Sentry alerts when DataDog runs SyntheticChecks
      // this is a noop when executing in production. it is effectively a 0-tick wait that prevents a race condition
      setTimeout(() => {
        window.location.reload();
      }, 0);
    }
  }, [isUserSuspended]);
}
